import { Button } from "@mui/material";
import { Container } from "@mui/system";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

type CustomDialogProps ={
    title?: string,
    text?: string,
    buttonText: string,
    flagOnClose?: boolean,
    onClick: React.MouseEventHandler<HTMLButtonElement>,
    open: boolean,
    bgcolor?: string,
}

const CustomDialog = (
    {title = undefined, text = undefined, buttonText, flagOnClose = false, onClick,
    open, bgcolor='none'}:CustomDialogProps) => {

    return(
        <>
        <Container component = "main" maxWidth = "xs" >
            <Dialog
                // BackdropProps={{ style: { backgroundColor: bgcolor }}}
                open={open}
                fullWidth
                onClose={flagOnClose? onClick: ()=>{}}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                {title &&
                <DialogTitle  id="alert-dialog-title" sx = {{background:bgcolor}}>
                    {title}
                </DialogTitle>
                }
                {text &&
                <DialogContent sx ={{background:bgcolor}}>
                    <DialogContentText id="alert-dialog-description">
                        {text}
                    </DialogContentText>
                </DialogContent>
                }
                <DialogActions sx = {{background:bgcolor}}>
                    <Button
                        color = {bgcolor=='none'?"primary":"inherit"}
                        variant = "outlined"
                        onClick = {onClick}
                        size = "large">
                        {buttonText}
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
        </>
    );
}
export default CustomDialog;
